import PublishedQuestionDescription, {
  PublishedQuestionDescriptionProps,
} from './PublishedQuestionDescription';
import UnpublishedQuestionDescription, {
  UnpublishedQuestionDescriptionProps,
} from './UnpublishedQuestionDescription';

export interface QuestionDescriptionProps
  extends UnpublishedQuestionDescriptionProps,
    PublishedQuestionDescriptionProps {
  isPollPublished: boolean;
}

const QuestionDescription = ({
  isPollPublished,
  pollQuestion,
  formMethods,
  onSubmit,
  onLocalSubmit,
  className,
}: QuestionDescriptionProps) => {
  if (isPollPublished)
    return <PublishedQuestionDescription pollQuestion={pollQuestion} className={className} />;

  return (
    <UnpublishedQuestionDescription
      formMethods={formMethods}
      onSubmit={onSubmit}
      onLocalSubmit={onLocalSubmit}
      pollQuestion={pollQuestion}
      className={className}
    />
  );
};

export default QuestionDescription;
